import { DEFAULTS_TABLE } from '@udecode/slate-plugins';

export const deserializeTable = {
    rules: [
        {
            className: DEFAULTS_TABLE.table.rootProps?.className,
        },
    ],
};
